/*
 * @Author: 李才人
 * @Date: 2021-07-29 16:42:12
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-09 17:50:18
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\config\questionnaire.ts
 * @Description:
 */

export enum IQuestionComonentType {
  Question = 0,
  Decoration = 1,
}

export interface optionItem {
  value: string;
  content: string;
  rightOption?: boolean;
}
export interface IQuestion {
  id?: string;
  qbid?: string;
  required?: number;
  number?: number;
  type?: QuestionType;
  style?: IQuestionComonentType;
  url?: string;
  whetherJoinQuestionBank?: boolean;
  fromQuestionBank?: boolean;
  catalogIds?: [];
}
export interface ISingleChoiceData extends IQuestion {
  title: string;
  itemScore?: number;
  required: number;
  optionContentType: string; // 是否必填: number;
  optionsList: Array<optionItem>;
}
export interface IMultipleChoiceData extends IQuestion {
  title: string;
  required: number;
  optionContentType: string; // 是否必填: number;
  itemScore?: number;
  optionsList: Array<optionItem>;
}

export interface IFillInData extends IQuestion {
  title: string;
  required: number;
  content: string;
  itemScore?: number;
  rightText?: string;
  scoreRule?: string;
}
export interface ISelectedoptionsData extends IQuestion {
  title: string;
  required: number;
  optionsList: Array<optionItem>;
}
export interface IPhoneNumberData extends IQuestion {
  title: string;
  required: number;
  phoneNumber: string;
}

export interface IAddonData extends IQuestion {
  required: number;
  uploadLimitCount: number;
  title: string;
}

export interface IImageData extends IQuestion {
  required?: number;
  url?: string;
}
export interface ITextTData extends IQuestion {
  required?: number;
  text?: string;
}

export interface IQuestionItem<T> {
  type: number;
  name: string;
  title: string;
  componentName: QuestionType | DecorationType;
  icon: string;
  data?: T;
  // url?: ""; // $ 图片地址
}
export enum DecorationType {
  picture = "5",
  text = "8",
  empty = "-1",
}

export enum QuestionType {
  empty = "-1",
  singleChoice = "1",
  multipleChoice = "2",
  fillIn = "3",
  cascade = "4",
  uploadAddon = "6",
  phoneNumber = "7",
}
export type QuestionFormDataType = ISingleChoiceData | IMultipleChoiceData | IFillInData | ISelectedoptionsData | IPhoneNumberData | IAddonData | IImageData | ITextTData;
export const questionData: Array<IQuestionItem<QuestionFormDataType>> = [
  {
    type: IQuestionComonentType.Question,
    name: "单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoice,
    icon: "",
    data: {
      required: 1,

      optionContentType: "TEXT", //
      optionsList: [
        { value: "1", content: "选项1" },
        { value: "2", content: "选项2" },
      ],
    } as ISingleChoiceData,
  },
  {
    type: IQuestionComonentType.Question,
    name: "多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT", //

      optionsList: [
        { value: "1", content: "选项1" },
        { value: "2", content: "选项2" },
      ],
    } as IMultipleChoiceData,
  },
  {
    type: IQuestionComonentType.Question,
    name: "填空题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
    } as IFillInData,
  },
  // {
  //   type: IQuestionComonentType.Question,
  //   name: "级联题",
  //   title: "请选择以下选项",
  //   componentName: QuestionType.cascade,
  //   icon: "",
  //   data: {
  //     required: 1,
  //     title: "",
  //     optionsList: [],
  //   } as ISelectedoptionsData,
  // },
  {
    type: IQuestionComonentType.Question,
    name: "手机号码",
    title: "您的手机号码是？",
    componentName: QuestionType.phoneNumber,
    icon: "",
    data: {
      phoneNumber: "",
      required: 1,
    } as IPhoneNumberData,
  },
  {
    type: IQuestionComonentType.Question,
    name: "上传附件",
    title: "请上传附件",
    componentName: QuestionType.uploadAddon,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
    } as IAddonData,
  },
];
export const testData: Array<IQuestionItem<QuestionFormDataType>> = [
  {
    type: IQuestionComonentType.Question,
    name: "单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoice,
    icon: "",
    data: {
      required: 1,
      itemScore: 0,
      optionContentType: "TEXT", //
      optionsList: [
        { value: "1", content: "选项1", rightOption: true },
        { value: "2", content: "选项2", rightOption: false },
      ],
    } as ISingleChoiceData,
  },
  {
    type: IQuestionComonentType.Question,
    name: "多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoice,
    icon: "",

    data: {
      required: 1,
      itemScore: 0,
      optionContentType: "TEXT", //
      optionsList: [
        { value: "1", content: "选项1", rightOption: true },
        { value: "2", content: "选项2", rightOption: true },
      ],
    } as IMultipleChoiceData,
  },
  {
    type: IQuestionComonentType.Question,
    name: "填空题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      itemScore: 0,
      rightText: "",
      scoreRule: "INCLUDE",
    } as IFillInData,
  },
];
export type QuestionDataType = typeof questionData;
export const decorationData: Array<IQuestionItem<QuestionFormDataType>> = [
  {
    type: IQuestionComonentType.Decoration,
    name: "图片",
    title: "请上传图片",
    componentName: DecorationType.picture,
    icon: "",
    data: {
      url: "",
      number: 0,
    } as IImageData,
  },
  {
    type: IQuestionComonentType.Decoration,
    name: "文字",
    title: "请填写文字",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: "",
    } as ITextTData,
  },
];

export type DecorationDataType = typeof decorationData;
